import {
  ExpressionPath,
  Expressions,
  Variable,
  matchExpression,
} from '@packages/systems/wfdl';
import {identifierToString, getName} from '@packages/systems/wfdl-Qualified';
import {type Expression} from '@packages/systems/wfdl-ast';

import {
  FLOW_TRIGGER_TYPES,
  type FlowTriggerEnum,
} from '@packages/systems/flows/types';

const getVariableName = matchExpression({
  Variable: Variable.match({
    qualified: (name) => identifierToString(getName(name)),
    unqualified: () => null,
  }),
  _: () => null,
});

const path = [
  {in: 'Function'},
  {in: 'Call', at: 'fun'},
  {in: 'Call', at: 'arg'},
  {in: 'Call', at: 'fun'},
] satisfies ExpressionPath;

export const getFlowTriggerType = (
  flowExpr: Expression
): null | FlowTriggerEnum => {
  const pathToTrigger = Expressions.isFunction(flowExpr)
    ? path
    : // When the trigger block is selected
      path.slice(1);

  const expr = Expressions.getIn(flowExpr, pathToTrigger);
  let name = expr ? getVariableName(expr) : null;
  // TODO: return formTrigger plugin to form_submission
  name = name === 'formTrigger' ? FLOW_TRIGGER_TYPES.form_submission : name;

  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly form_submission: "form_submission"; readonly collection_item_updated: "collection_item_updated"; readonly collection_item_created: "collection_item_created"; readonly collection_item_deleted: "collection_item_deleted"; readonly webhook: "webhook"; }'.
  return name ? FLOW_TRIGGER_TYPES[name] : null;
};
